import { useTranslation } from "react-i18next";

// Mail strings are full English sentences used as keys, so "." and ":" must not be
// treated as key/namespace separators.
export const useMailTranslation = () => {
  const { t, i18n } = useTranslation("mail");
  const tr = (key, options) => t(key, { keySeparator: false, nsSeparator: false, ...options });
  return { t: tr, i18n };
};
